import { Component, OnDestroy, OnInit } from "@angular/core";
import { FooterComponent } from "../footer/footer.component";
import {
  NavigationEnd,
  NavigationStart,
  Router,
  RouterOutlet,
} from "@angular/router";
import { NavbarComponent } from "../navbar/navbar.component";
import { SidebarComponent } from "../sidebar/sidebar.component";
import {
  AGENT_DASHBOARD_ROUTES,
  DASHBOARD_ROUTES,
} from "./dashboard-routes.routes";
import { CommandPaletteComponent } from "src/app/shared/command-palette/command-palette.component";
import { ImpersonationBannerComponent } from "src/app/shared/impersonation-banner/impersonation-banner.component";
import { AuthService } from "src/app/services/auth.service";
import { Subject, takeUntil } from "rxjs";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-dashboard-layout",
    templateUrl: "./dashboard-layout.component.html",
    styleUrls: ["./dashboard-layout.component.scss"],
    imports: [
        SidebarComponent,
        NavbarComponent,
        RouterOutlet,
        FooterComponent,
        CommonModule,
        CommandPaletteComponent,
        ImpersonationBannerComponent,
    ]
})
export class DashboardLayoutComponent implements OnInit, OnDestroy {
  isPageChange: boolean = false;
  routeGroup = DASHBOARD_ROUTES;
  isSidebarOpen: boolean = false;
  isMobile: boolean = false;
  isMobileNavOpen: boolean = false;

  private destroy$ = new Subject<void>();
  private readonly onResize = () => this.checkScreenSize();
  private navOpenObserver?: MutationObserver;

  constructor(private _router: Router, private authService: AuthService) {}

  ngOnInit() {
    // Gérer les changements de route
    this._router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isPageChange = true;
      } else if (event instanceof NavigationEnd) {
        this.isPageChange = false;
        // Fermer la sidebar sur mobile après navigation
        if (this.isMobile) {
          this.isSidebarOpen = false;
        }
      }
    });

    // Gérer les permissions utilisateur : seul un SystemAdmin voit le menu
    // complet (DASHBOARD_ROUTES) ; SUPER/AGENT voient le menu agent réduit.
    // La sidebar applique en plus un filtre par requiredSystemRoles.
    this.authService.admin$
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        if (response && response.systemRole !== "SYSTEM") {
          this.routeGroup = AGENT_DASHBOARD_ROUTES;
        }
      });

    // Détecter la taille d'écran
    this.checkScreenSize();
    window.addEventListener("resize", this.onResize);

    // Sync with NavbarComponent behavior (it toggles `html.nav-open` on mobile, `html.sidebar-collapsed` on desktop).
    const html = document.getElementsByTagName("html")[0];
    this.isMobileNavOpen = html.classList.contains("nav-open");
    this.isSidebarOpen = !html.classList.contains("sidebar-collapsed");
    this.navOpenObserver = new MutationObserver(() => {
      this.isMobileNavOpen = html.classList.contains("nav-open");
      this.isSidebarOpen = !html.classList.contains("sidebar-collapsed");
    });
    this.navOpenObserver.observe(html, { attributes: true, attributeFilter: ["class"] });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    window.removeEventListener("resize", this.onResize);
    this.navOpenObserver?.disconnect();
  }

  get menuSidebar() {
    return this.routeGroup;
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  closeMobileNav = () => {
    // NavbarComponent opens/closes the mobile sidebar via `html.nav-open`.
    // Keep this layout compatible: scrim click should close it.
    const html = document.getElementsByTagName("html")[0];
    const mainPanel = document.getElementsByClassName("main-panel")[0] as
      | HTMLElement
      | undefined;

    html.classList.remove("nav-open");
    this.isMobileNavOpen = false;
    if (mainPanel) {
      mainPanel.style.position = "";
    }
  };

  private checkScreenSize() {
    this.isMobile = window.innerWidth < 768;
    if (!this.isMobile) {
      this.isSidebarOpen = true;
    }
  }

  logout() {
    // this.authService.logout();
    this._router.navigate(["/login"]);
  }
}
